import { render } from "./user-product-launch.vue?vue&type=template&id=2044cbc8&scoped=true"
import script from "./user-product-launch.vue?vue&type=script&lang=js"
export * from "./user-product-launch.vue?vue&type=script&lang=js"

import "./user-product-launch.vue?vue&type=style&index=0&id=2044cbc8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2044cbc8"]])

export default __exports__